import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '../../../components/Button.js';
import Alert from '@material-ui/lab/Alert';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { ProviderAPI } from '../../../api';
import Loader from '../../../components/Loader.js';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
    maxWidth: '9rem',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    cursor: 'pointer',
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: theme.palette.common.highlightBlue,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    padding: '0',
  },
  title: {
    marginBottom: '1rem',
  },
  controls: {
    padding: '1rem 0',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '1rem',
  },
  alert: {
    width: '100%',
  },
});

const PremisesSummary = ({providerUuid, selectPremises, newPremises}) => {
  const classes = useStyles();
  const [showActiveOnly, setShowActiveOnly] = React.useState(false);
  const [data, setData] = React.useState(null);

  const toggleStatus = () => {
    setShowActiveOnly(!showActiveOnly);
  };

  const getData = async () => {
    try {
      const premises = await ProviderAPI.getPremises(providerUuid, showActiveOnly);
      setData(premises.payload);
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
    }
  };

  const selectChipColor = (active) => {
    if (active === true) {
      return 'lightGreen';
    } else {
      return 'orange';
    }
  };

  React.useEffect(() => {
    getData();
  }, [showActiveOnly]);  // eslint-disable-line

  if (data === null) {
    return (<Loader />);
  }

  return (
    <div className={classes.root}>

      {data.length === 0 ? (
        <div className={classes.alert}>
          <Alert severity="info">
            No premises have been configured.
          </Alert>
        </div>
      ) : null}

      <div className={classes.controls}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showActiveOnly}
              onChange={toggleStatus}
            />
          }
          label="Show active premises only"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={newPremises}
          label="New premises"
          className={classes.button}
          pointer="plus"
        />
      </div>

      {data.length > 0 ? (
        <TableContainer>
          <Table className={classes.table} aria-label="Premises table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Address</StyledTableCell>
                <StyledTableCell>Active</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <StyledTableRow
                  key={row.uuid}
                  onClick={() => selectPremises(row.uuid)}
                >
                  <StyledTableCell>{row.name}</StyledTableCell>
                  <StyledTableCell>{row.formatted_address}</StyledTableCell>
                  <StyledTableCell><Chip label={row.active === true ? 'Yes' : 'No'} style={{backgroundColor:selectChipColor(row.active)}} /></StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}

    </div>
  );
};

PremisesSummary.propTypes = {
  providerUuid: PropTypes.string.isRequired,
  selectPremises: PropTypes.func.isRequired,
  newPremises: PropTypes.func.isRequired,
};

export default PremisesSummary;
